import { TextField } from '@material-ui/core'
import { Field } from 'formik'
import { useState } from 'react'
import { useStyles } from './style'

export function InputTextArea({
  name = '',
  type = '',
  label,
  required,
  ...rest
}) {
  const classes = useStyles()
  const [isFocused, setIsFocused] = useState(false)
  return (
    <div className={classes.root}>
      {label && (
        <label
          htmlFor={name}
          className={`${classes.inputLabel} ${
            isFocused ? classes.inputLabelFocused : ''
          }`}
        >
          {label}
        </label>
      )}
      <Field
        as={TextField}
        name={name}
        type={type}
        variant="outlined"
        {...rest}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className={classes.inputField}
      />
      {/* <ErrorMessage name={name} /> */}
    </div>
  )
}
